import { render, staticRenderFns } from "./BottomControlsButtons.vue?vue&type=template&id=5283623f"
import script from "./BottomControlsButtons.vue?vue&type=script&lang=ts"
export * from "./BottomControlsButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
